export const colors = {
  white: "#fff",
  gold: " 	#FFD700",
  orange: "#B95A37",
  light: "rgba(255, 255, 255, 0.5)",
  lighter: "rgba(255, 255, 255, 0.2)",
  black: "#343a40",
  darkGrey: "#6c757d",
}
